import type { PrintJobHistoryEntry, PrintOutcome } from "./types";

type OutcomeFields = Pick<PrintJobHistoryEntry, "shadow" | "status" | "confirmed_outcome">;

// A real print can't report whether the label came out, so it ends
// "uncertain". Staff don't have to confirm each one: it reads as sent, and
// only a label that didn't come out needs reporting.
export function printResultToast(result: { label_count: number; shadow: boolean }): string {
  const plural = result.label_count === 1 ? "" : "s";
  return result.shadow
    ? `${result.label_count} simulated label${plural} added to shadow job`
    : `${result.label_count} label${plural} sent to the printer`;
}

export function reprintResultToast(result: { shadow: boolean }): string {
  return result.shadow
    ? "Reprint job created (shadow only — nothing prints physically)"
    : "Reprint sent to the printer";
}

export function canReportNotPrinted(entry: OutcomeFields): boolean {
  return !entry.shadow && entry.status === "uncertain" && !entry.confirmed_outcome;
}

export function historyStatusLabel(entry: OutcomeFields): string {
  if (entry.shadow || entry.status !== "uncertain") return entry.status.replaceAll("_", " ");
  if (entry.confirmed_outcome === "printed") return "printed (checked)";
  if (entry.confirmed_outcome === "not_printed") return "didn't print (reported)";
  return "sent to printer";
}

export function outcomeConfirmedToast(outcome: PrintOutcome): string {
  return outcome === "printed"
    ? "Marked as printed"
    : "Reported as not printed — reprint it if the label is still needed";
}
